var functions = {}

functions.hasValue = function (value) {
    if (value == null) {
        return false;
    }
    if (value == undefined) {
        return false;
    }
    if (typeof value === 'string' || value instanceof String) {
        return hasValueString(value)
    } else if (typeof value === 'number' || value instanceof Number) {
        return hasValueNumber(value)
    }
    return true;
}

function hasValueString(valueString) {
    if (valueString.length == 0) {
        return false;
    }
    return true;
}

function hasValueNumber(valueNumber) {
    if (valueNumber > 0) {
        return true;
    }
    return false;
}

functions.generateGuid = () => {
    var S4 = function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
};

Date.prototype.monthNames = [
    "Janeiro", "Fevereiro", "Março",
    "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro",
    "Outubro", "Novembro", "Dezembro"
];
Date.prototype.getMonthName = function () {
    return this.monthNames[this.getUTCMonth()];
};
Date.prototype.getShortMonthName = function () {
    return this.getMonthName().substr(0, 3);
};

module.exports = functions


// WEBPACK FOOTER //
// ./src/utils/functions.js